import { Component } from '@angular/core';

@Component({
  selector: 'app-form-devolver',
  templateUrl: './form-devolver.component.html',
  styleUrls: ['./form-devolver.component.css']
})
export class FormDevolverComponent {

}
